import * as React from 'react'
import { styles } from './styles'

interface HighlightMatchProps {
  text: string
  query?: string
}

const escapeRegExp = (value: string): string =>
  value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

/** Wraps every occurrence of `query` inside `text` in a highlight span (case-insensitive). */
const HighlightMatch = ({ text, query }: HighlightMatchProps) => {
  const classes = styles()
  const trimmedQuery = query?.trim()

  if (!trimmedQuery) return <>{text}</>

  const parts = text.split(new RegExp(`(${escapeRegExp(trimmedQuery)})`, 'i'))
  if (parts.length === 1) return <>{text}</>

  return (
    <>
      {parts.map((part, index) =>
        // split() with a capturing group always puts matches at odd indices
        index % 2 === 1 ? (
          <mark key={index} className={classes.highlight}>
            {part}
          </mark>
        ) : (
          <React.Fragment key={index}>{part}</React.Fragment>
        )
      )}
    </>
  )
}

export default HighlightMatch
